import jsPDF from "jspdf";
import moment from "moment";
import { IDecimoTerceiro } from '../../models/DecimoTerceiro';



interface PropsPdf{
    decimoTerceiro: IDecimoTerceiro[],
}

export const criarPdf = ({
    cnpj,
    codVerbasDescontos,
    codVerbasProventos,
    cpf,
    dataAdmissao,
    descCentroCusto,
    descProventos,
    descontosTotais,
    descontosVerbas,
    filial,
    funcao,
    id,
    matricula,
    nome,
    nomeEmpresa,
    periodoFol,
    proventosTotais,
    proventosValores,
    referenciaDescontos,
    referenciaProventos,
    salB,
    salL,
    verbas,   
    periodo,
    ano 
}:IDecimoTerceiro):void => {

    const pdf = new jsPDF("P", "mm", "a4")

    function moedaReal(moeda: number): string {
        return moeda.toLocaleString('pt-br', { minimumFractionDigits: 2 });
      }

    var funcao = (descCentroCusto).split("-")[0]
    var codEmpresa = (descCentroCusto).split("-")[1]
    var codPosto = (descCentroCusto).split("-")[2]
    var posto = (descCentroCusto).split("-")[3]

    pdf.rect(20, 40, 170, 21)
    pdf.rect(20, 63, 170, 29)
    pdf.rect(20, 94, 170, 50)
    pdf.rect(20, 146, 170, 16)
    pdf.rect(20, 166, 170, 21)

    var imgData = 'data:image/png;base64,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'


    pdf.addImage(imgData, 'PNG', 20, 7, 50, 30)
    console.log(periodo, ano)


    // CABEÇALHO

    pdf.setFont("arial")
    pdf.setFontStyle("bold")
    pdf.setFontSize(10)
    pdf.text("GRUPO SERVNAC", 158, 15)

 
    pdf.setFontStyle("normal")
    pdf.text("Rua Paulo Esteferson Bezerra 185", 141, 20)


    pdf.text("Jangurussu, Fortaleza - CE", 151, 24)


    pdf.text("CEP - 60870-520", 164, 29)
    
    // FIM CABEÇALHO


    // 1° QUADRADO

    pdf.setFont("arial")
    pdf.setFontStyle("bold")
    pdf.setFontSize(10)
    pdf.text(nomeEmpresa, 22, 46)
  

    pdf.text("CNPJ: "+cnpj, 22, 55)
    
    pdf.text("RECIBO DE PAGAMENTO DE SALÁRIO", 122, 46)

    pdf.text(periodo+"/"+ano, 150, 55)

    // FIM 1° QUADRADO

    // 2° QUADRADO

    pdf.setFont("arial")
    pdf.setFontStyle("bold")
    pdf.setFontSize(10)
    pdf.text("Código", 22, 69)


    pdf.setFontStyle("normal")

    pdf.text(matricula, 22, 75)


    pdf.setFontStyle("bold")

    pdf.text("Nome do Funcionário", 47, 69)


    pdf.setFontStyle("normal")

    pdf.text(nome, 47, 75)


    pdf.setFontStyle("bold")

    pdf.text("CBO Emp. Local Depto. Setor Seção FI.", 114, 69)


    pdf.setFontStyle("normal")

    pdf.text(funcao, 114, 75)


    pdf.text(codEmpresa, 114, 80)


    pdf.text(codPosto, 114, 85)


    pdf.text(posto, 114, 90)

    // FIM 2° QUADRADO

    // 3° QQUADRADO


    pdf.setFontStyle("bold")

    pdf.text("Cod", 22, 99)


    pdf.setFontStyle("normal")

    var altura = 0
    codVerbasProventos.map(
        (item, index)=> {
            altura = 104+5*index
            return pdf.text(item, 22, 104+5*index)
        }
    )
    codVerbasDescontos.map(
        (item, index)=> {
            return pdf.text(item, 22, altura+5*(index+1))
        }
    )


    pdf.setFontStyle("bold")

    pdf.text("Descrição", 52, 99)


    pdf.setFontStyle("normal")


    descProventos.map(
        (item, index)=> {
            return pdf.text(item, 52, 104+5*index)
        }
    )
    verbas.map(
        (item, index)=> {
            return pdf.text(item, 52, altura+5*(index+1))
        }
    )


    pdf.setFontStyle("bold")
    pdf.text("Referência", 100, 99)


    pdf.setFontStyle("normal")
    referenciaProventos.map(
        (item, index)=> {
            return pdf.text(""+item, 106, 104+5*index)
        }
    )
    referenciaDescontos.map(
        (item, index)=> {
            return pdf.text(""+item, 106, altura+5*(index+1))
        }
    )


    pdf.setFontStyle("bold")
    pdf.text("Proventos", 130, 99)


    pdf.setFontStyle("normal")
    proventosValores.map(
        (item, index)=> {
            return pdf.text(""+item, 132, 104+5*index)
        }
    )
    descontosVerbas.map(
        (item, index)=> {
            return pdf.text("-", 135, altura+5*(index+1))
        }
    )


    pdf.setFontStyle("bold")
    pdf.text("Descontos", 160, 99)


    pdf.setFontStyle("normal")
    codVerbasProventos.map(
        (item, index)=> {
            return pdf.text("-", 167, 104+5*index)
        }
    )
    descontosVerbas.map(
        (item, index)=> {
            return pdf.text(""+item, 164, altura+5*(index+1))
        }
    )

    // FIM 3° QUADRADO

    // 4° QUADRADO


    pdf.setFontStyle("bold")
    pdf.text("Total de vencimentos", 86, 150)
    

    pdf.text(""+proventosTotais, 94, 157)


    pdf.text("Total de Descontos", 125, 150)


    pdf.text(""+moedaReal(descontosTotais), 133, 157)


    pdf.text("Valor Líquido", 160, 150)


    pdf.text(""+moedaReal(salL), 169, 157)

    // FIM 4° QUADRADO

    // 5° QUADRADO


    pdf.text("Salário Base", 22, 171)


    pdf.text(""+salB, 26, 177)


    pdf.text("Sal. Contr. INSS", 48, 171)


    pdf.setFontStyle("normal")
    pdf.text("-", 60, 177)


    pdf.setFontStyle("bold")
    pdf.text("Base Cálc. FGTS", 80, 171)


    pdf.setFontStyle("normal")
    pdf.text("-", 92, 177)


    pdf.setFontStyle("bold")
    pdf.text("FGTS do Mês", 112, 171)


    pdf.setFontStyle("normal")
    pdf.text("-", 122, 177)


    pdf.setFontStyle("bold")
    pdf.text("Base Cálc. IRRF", 140, 171)


    pdf.setFontStyle("normal")
    pdf.text("-", 152, 177)


    pdf.setFontStyle("bold")
    pdf.text("Faixa IRRF", 170, 171)


    pdf.setFontStyle("normal")
    pdf.text("-", 178, 177)

    // FIM 5° QUADRADO


    pdf.setFontSize(8)
    pdf.text("Contra Cheque gerado em: "+moment().format("DD/MM/YYYY - HH:mm ")+ "código: "+ id, 50, 192)


    pdf.autoPrint()
    pdf.output("dataurlnewwindow")
    //pdf.save("Décimo-Terceiro.pdf")
}



